module.exports = __webpack_public_path__ + "assets/img/services4.156c3c65.svg";